import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/services";

export default function ServicesGrid() {
  return (
    <section className="py-16 md:py-20">
      <div className="container">
        <div className="mb-10 max-w-2xl">
          <h2 className="mb-3 text-3xl font-bold tracking-tight md:text-4xl">What we do</h2>
          <p className="text-body">
            Specialist HVAC across Mangawhai, Northland and Auckland — for homes, hospitality, retail and commercial spaces.
          </p>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map(({ id, title, short, image }) => (
            <Link
              key={id}
              to={`/services#${id}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-border/60 bg-white transition hover:-translate-y-0.5 hover:border-brand hover:shadow-md"
            >
              <div className="flex aspect-[4/3] w-full items-center justify-center bg-white p-4">
                <img
                  src={image}
                  alt={title}
                  loading="lazy"
                  className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col border-t border-border/60 p-6">
                <h3 className="mb-2 text-lg font-semibold text-ink">{title}</h3>
                <p className="mb-5 flex-1 text-sm text-body">{short}</p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-brand">
                  Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
